import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

/**
 * グローバルキーボードショートカット。
 * - Esc: モーダル/ボトムシートを閉じる・トーストを消す・入力からフォーカスを外す
 * - n: 新規議事録作成
 * - /: 検索ボックスにフォーカス
 * - 1/2/3/4: 会議予定 / 議事録 / TODO / 設定 へ移動
 * 入力中（input/textarea/contentEditable）は Esc 以外無効。
 */
export function KeyboardShortcuts() {
  const navigate = useNavigate()

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      const target = e.target as HTMLElement | null
      const isTyping = !!target && (
        target.tagName === 'INPUT' ||
        target.tagName === 'TEXTAREA' ||
        target.tagName === 'SELECT' ||
        target.isContentEditable
      )

      if (e.key === 'Escape') {
        // 1) トーストを消す
        const toasts = document.querySelectorAll('.toast')
        if (toasts.length > 0) {
          toasts.forEach((t) => t.remove())
          return
        }
        // 2) モーダル/ボトムシートを閉じる（キャンセル・閉じるボタン優先、なければオーバーレイをクリック）
        const overlays = document.querySelectorAll<HTMLElement>('.modal-overlay')
        const overlay = overlays[overlays.length - 1]
        if (overlay) {
          const buttons = Array.from(overlay.querySelectorAll<HTMLButtonElement>('button'))
          const closeBtn = buttons.find((b) => {
            const label = `${b.textContent || ''}${b.getAttribute('aria-label') || ''}${b.title || ''}`
            return /キャンセル|閉じる|×|✕/.test(label)
          })
          if (closeBtn) {
            closeBtn.click()
          } else {
            overlay.click()
          }
          return
        }
        // 3) 開いているドロップダウンを閉じる（背面の透明オーバーレイをクリック）
        const backdrop = document.querySelector<HTMLElement>('.fixed.inset-0')
        if (backdrop) {
          backdrop.click()
          return
        }
        // 4) 入力中ならフォーカスを外す
        if (isTyping && target) target.blur()
        return
      }

      // 修飾キー付き・入力中は無視
      if (isTyping || e.metaKey || e.ctrlKey || e.altKey) return

      switch (e.key) {
        case 'n':
          e.preventDefault()
          navigate('/create')
          break
        case '/': {
          e.preventDefault()
          const search = document.querySelector<HTMLInputElement>(
            'input[placeholder*="検索"], .search-bar input'
          )
          search?.focus()
          break
        }
        case '1':
          navigate('/')
          break
        case '2':
          navigate('/documents')
          break
        case '3':
          navigate('/tasks')
          break
        case '4':
          navigate('/settings')
          break
      }
    }

    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [navigate])

  return null
}
